/* Global event handlers and startup
 *
 * Moved verbatim from currencykeep_2026-08-03.html, lines 1004-1053.
 * The body below is byte-identical to the original; only the import
 * block above and the export block below were added. (Phase 1, Step 2.)
 */

import { isSignedIn } from './auth.js'
import { BY_SID, CATALOG, customGradeKey } from './catalog.js'
import { buildDemos, loadProfile, loadPublic, republish } from './community.js'
import { MATCHED_TOAST, OTHER_TYPE, convertToRow, enterOther, isCust, isOther, loadCustom, pruneEmptyCustom, quickAdd, revertToCustom, saveCustom, startAdd } from './custom.js'
import { backfillYears } from './filters.js'
import { WIDE_A, WIDE_B, markLayout, offbar, render } from './render.js'
import { $, cat, load, save, state, toast } from './state.js'
import { TIER_FOR } from './photo-view.js'
import { retryCommunityPhotos } from './community-photos.js'
import { HAS } from './storage.js'
import { setUsername } from './username.js'
import { bootFromUrl, bootSession, gateScreen, requireSession } from './views-auth.js'
import { abortSlotUploads } from './migrate.js'
/* ⚠ `withoutMark` SURVIVES THE COLUMN AND `withMark` DOES NOT: the
 * toggle no longer WRITES the memo, but the tap still has to CLEAN a
 * lingering mark off it during the transition — see the handler. */
import { carryOverMark, qualifierOn, readMark, withoutMark } from './memo.js'
import { IDENTITY_FIELD, OTHER_LEAD, RAW_FILL_FIELD, YEAR_FILL_FIELD,clearDifferent, clearLookup, clearPending, clearPendingFor, clearUnchecked, getLookup, getPending, getReading, revealDetails, setReadingField, TYPE_LEAD } from './pending.js'
import { fillFromReading, flushNoFrFill, pickCandidate, seeLikelyNotes, syncNoFrFill, updateToDifferent } from './suggest.js'
/* his #11: a Type set in Note details carries back to the card when it is
 * one of the card's own options */
import { TYPE_OPTIONS } from './note-narrow.js'

/**
 * ⏸ THE CARRY-OVER'S ONE CALLER — his ruling 1, 2026-09-21: *"The
 * carry-over runs in the CLIENT, once, reusing the proven removal
 * function — not a second copy in SQL."*
 *
 * ⚠ IT SITS BESIDE `backfillYears()` IN THE BOOT SEQUENCE AND THAT IS
 * THE PRECEDENT, not a coincidence: `filters.js:21` is the same shape —
 * a one-time sweep of the loaded collection that saves only if it
 * changed something, with no "has migrated" flag to store or forget.
 * Both run AFTER the collection is loaded (`bootFromUrl`/`bootSession`)
 * and BEFORE `render()`, so the first paint already shows the new shape.
 *
 * ⚠⚠ `republish()` AND NOT JUST `save()`, because `qualifier` is public
 * now — a device that carried a collector's letters over without
 * republishing would show a stranger OFF while the owner saw ON. Same
 * defect Jesse caught on the toggle tap; fixed in both places at once
 * rather than only where he pointed.
 *
 * ⚠ SIGNED OUT, `state.collection` IS EMPTY and this is a no-op that
 * saves nothing — which is why it is safe to call unconditionally rather
 * than inside the `isSignedIn()` branch.
 */
function carryOverQualifier(){const n=carryOverMark(state.collection);if(n){save();republish();console.log("carried over",n,"EPQ/PPQ marks to the qualifier field");}}
import './editor.js'

/* ---------- events ---------- */
document.addEventListener("click",e=>{
  const t=e.target.closest("[data-nav],[data-note],[data-hold],[data-back],[data-addfrom],[data-filter],[data-setgrade],[data-setqual],[data-remove],[data-quickadd],[data-savenote],[data-notright],[data-diffupdate],[data-diffkeep],[data-diffsee],[data-uncheckdismiss],[data-pickrow],[data-rdtype],[data-rdans],[data-rdmore]");
  if(!t)return;
  /* ⚠ + ADD FROM AN OPEN NOTE — his ruling 6 of 2026-10-24: in B the button stays on a note. It leaves the note
   * the way a tab tap does (the empty quick-add pruned, the viewer closed, the no-Fr fill saved once, the marks
   * cleared) before the new one opens. On a phone the button is hidden on a note, so this never runs there. */
  if("quickadd"in t.dataset){if(state.screen==="holding"&&state.sel){pruneEmptyCustom();state.vaultZoom=null;flushNoFrFill(state,state.collection.find(x=>x.id===state.sel));clearPendingFor(state,state.sel);}quickAdd();return;}
  /* ══ STEP 6, HIS RULING 2026-09-26 — "THIS IS MY NOTE": the collector's
   * tap on a candidate row is the ONE way a raw reading reaches the
   * note's identity (suggest.js `pickCandidate` carries the rule); the
   * same toast a typed Fr says. */
  if("pickrow"in t.dataset){const h=state.collection.find(x=>x.id===state.sel);if(!h)return;
    const row=pickCandidate(state,h,t.dataset.pickrow);render();if(row)toast(MATCHED_TOAST(row.fr));return;}
  /* ══ STOP B, HIS RULING 1 (2026-09-27): the answer to "large or small?"
   * (or the Treasury issue) is a Type pick — the collector's, with the ✎. */
  if("rdtype"in t.dataset){const h=state.collection.find(x=>x.id===state.sel);if(!h)return;
    setReadingField(state,h.id,"type",t.dataset.rdtype);syncNoFrFill(state,h);render();return;}
  /* ══ THE STOP B AMENDMENT (his F, G, I, #8): an answer button under a
   * question row is the collector's pick of that field, with the ✎ — the
   * same act as the size answer above. */
  if("rdans"in t.dataset){const h=state.collection.find(x=>x.id===state.sel);if(!h)return;
    setReadingField(state,h.id,t.dataset.rdans,t.dataset.rdv);syncNoFrFill(state,h);render();return;}
  /* "Add another detail" (his point 2): the rest of the details show. */
  if("rdmore"in t.dataset){revealDetails(state,state.sel);render();return;}
  /* ══ STEP 7.5, HIS RULING 2026-09-25 — "This photo looks like a different
   * note". UPDATE: the note becomes the photo's row, grade, qualifier and
   * year with it (suggest.js `updateToDifferent` carries the rule), and
   * the same toast a match says. KEEP: the line goes, nothing changes, and
   * the next photo asks again. */
  if("diffupdate"in t.dataset){const h=state.collection.find(x=>x.id===t.dataset.diffupdate);if(!h)return;
    const row=updateToDifferent(state,h);render();if(row)toast(MATCHED_TOAST(row.fr));return;}
  if("diffkeep"in t.dataset){clearDifferent(state,t.dataset.diffkeep);render();return;}
  /* his ruling of 2026-10-22: Dismiss on the unchecked line — the line goes, nothing changes */
  if("uncheckdismiss"in t.dataset){clearUnchecked(state,t.dataset.uncheckdismiss);render();return;}
  /* ══ HIS RULINGS OF 2026-10-06 — "See likely notes", the raw prompt's
   * button on a catalogue note: the whole card opens under it (suggest.js
   * `seeLikelyNotes`); a row tap there is `pickCandidate`'s, above. "Keep as
   * is" is the line above: the prompt goes, and the card with it — the view
   * draws a catalogue note's card only while the prompt stands. */
  if("diffsee"in t.dataset){const h=state.collection.find(x=>x.id===t.dataset.diffsee);if(!h)return;
    seeLikelyNotes(state,h);render();return;}
  /* ══ STEP 7.3(c), 2026-09-23 — "NOT THE RIGHT NOTE? TAP HERE." HIS RULING 2.
   * The note goes back to a blank custom entry (a NEW one — `revertToCustom`,
   * custom.js), keeping the photo, grade, notes and anything typed; the
   * identity ✨ clears with the marker, and the button goes with it because
   * the button IS the marker's presence. ⚠ The value ✨ stay: the grade and
   * the qualifier were still filled from the photo, and the marker is
   * honest either way. ⚠ No toast — the hero reading "New note" is the
   * whole statement, and nothing was ruled for the tap to say.
   * ⚠⚠ His detail: what the CONVERSION filled is cleared (the marker
   * recorded it — the year from the wrong row's series, a grade it moved);
   * what the collector typed stays; and a grade the PHOTO has since
   * filled (its own ✨ is on it) is the label's, so it is kept too. */
  if("notright"in t.dataset){const h=state.collection.find(x=>x.id===t.dataset.notright);if(!h)return;
    const mk=getPending(state,h.id,IDENTITY_FIELD);const f=(mk&&mk.filled)||{};
    /* ⚠ THE ✨'S VALUE GOES TOO — the gradeRead gap, his ruling B of 2026-10-29: the label's grade filled a
     * catalogue row, where no stamp can live, so the revert stamps the new entry (custom.js). */
    const gm=getPending(state,h.id,"grade");
    revertToCustom(h,{year:f.year,grade:gm?null:f.grade,read:gm?gm.value:null});
    clearPending(state,h.id,IDENTITY_FIELD);
    /* STEP 6: the card is still on `state`, so the new blank entry gets
     * the reading's denomination again, with its ✨ (his ruling 2) — and,
     * since his ruling of 2026-10-05, the card's Type with its ✨: the Type's
     * mark stands on the card from before the tap, and without the refill it
     * would sit on a "Custom entry" Type. Saved once (`fillFromReading`). */
    fillFromReading(state,h,cat(h.catId));render();return;}
  /* ⚠ TWO PANES (B): the open note's own card is a tap on what is already open — nothing is left, so nothing is
   * pruned, saved or cleared. Another card leaves the note as Back does, the empty quick-add pruned too. On a
   * phone the list is never on screen with a note open, so neither line runs there. */
  if(t.dataset.hold&&state.screen==="holding"&&t.dataset.hold===state.sel)return;
  if(state.screen==="holding"&&t.dataset.hold)pruneEmptyCustom();
  if(state.screen==="holding"&&(t.dataset.nav||t.dataset.back))pruneEmptyCustom();
  /* ⚠⚠ ANY NAVIGATION CLOSES THE VAULT ENLARGE, AND LEAVING IT SET WOULD
   * BE THE BUG — the same reasoning `username.js` records for `pubZoom`.
   * `vaultZoom` names a slot on `state.sel`, so carrying it to another
   * holding would open a viewer over a DIFFERENT note's photograph, and
   * carrying it off the screen entirely would leave a viewer waiting to
   * reappear. It is cleared here rather than in each branch because
   * every branch below leaves the holding screen. */
  if(t.dataset.nav||t.dataset.back||t.dataset.note||t.dataset.hold||t.dataset.remove)state.vaultZoom=null;
  /* ⚠ LEAVING THE NOTE SCREEN CLEARS ITS STARS — his ruling: they go on
   * Save or on leaving. Same branch as `vaultZoom` and for the same
   * reason: every path below leaves the holding, and clearing per-branch
   * is how one branch gets forgotten. ⚠⚠ NOT on autosave. */
  /* STOP B: a no-Fr fill the keystrokes left in memory is saved first, once. */
  if(state.screen==="holding"&&state.sel&&(t.dataset.nav||t.dataset.back||t.dataset.note||t.dataset.hold)){flushNoFrFill(state,state.collection.find(x=>x.id===state.sel));clearPendingFor(state,state.sel);}
  if(t.dataset.nav){state.screen=gateScreen(t.dataset.nav);if(t.dataset.nav==="add"){state.search="";state.filter="All";}render();}
  else if(t.dataset.note){state.sel=+t.dataset.note;state.screen="detail";render();}
  else if(t.dataset.hold){state.sel=t.dataset.hold;state.screen="holding";render();}
  else if(t.dataset.back){state.screen=t.dataset.back==="collection"?"collection":"catalog";render();}
  /* ⚠ NOTHING IS ADDED TO A VAULT THAT DID NOT LOAD — the offline-reload item's extra, his go and his words,
   * 2026-10-18: the write guard would refuse the save, but the note would sit in memory as if added. */
  else if(t.dataset.addfrom){if(requireSession()){if(state.vaultUnread){toast("Your vault hasn't loaded yet — tap Try again on your vault first.");return;}startAdd(+t.dataset.addfrom);}}
  else if(t.dataset.filter){state.filter=t.dataset.filter;render();}
  /* ⚠⚠⚠ THE ✨ CLEARS ON THE COLLECTOR'S OWN TAP — HIS RULE 3, 2026-09-21:
   * *"If they disagree, they tap the correct grade, and the ✨ on that field
   * disappears — it's their choice now."* ⚠ It is cleared HERE, on the tap,
   * and NOT inside `save()`: autosave fires on every keystroke in every
   * other field and would clear the stars before they were ever seen,
   * which is the one thing he named. */
  else if(t.dataset.setgrade){const h=state.collection.find(x=>x.id===state.sel);h.grade=t.dataset.setgrade;
    /* ⚠ OTHER'S STEP 5, HIS (b): a tap on ANOTHER grade takes the label's stamp off (custom.js `enterOther`); the same
     * grade tapped to confirm it keeps it (his yes). Saved with the entry. */
    const gn=cat(h.catId);if(gn&&gn.gradeRead!=null&&gn.gradeRead!==h.grade){delete gn.gradeRead;saveCustom();}
    clearPending(state,h.id,"grade");save();republish();render();}
  /* ~~The EPQ/PPQ toggle is a READ of memo (step 3.5): on = the word is
   * in the text, so a tap writes or removes the word and touches nothing
   * else. Which word is his 2026-09-16 service table (memo.js). save()
   * without republish: memo is private and not in the public
   * projection.~~
   *
   * ⚠⚠⚠ THAT LAST SENTENCE WAS THE DEFECT, AND IT SURVIVED THE REWRITE
   * BECAUSE I ADDED A BLOCK BELOW IT INSTEAD OF EDITING IT — METHOD RULE
   * 17, COMMITTED A SECOND TIME, ONE DAY AFTER WRITING THE RULE. **Jesse
   * caught it, not a gate and not the builder re-reading:** *"The EPQ/PPQ
   * toggle tap saves but doesn't republish. EPQ/PPQ is public now, so the
   * tap must do save · republish · render, the same as the grade tap —
   * otherwise a stranger's view of my profile shows the old value."*
   * ⚠ The stale sentence was not decoration: it was the whole reason
   * `republish()` was absent, so leaving it standing left the JUSTIFICATION
   * for a bug sitting directly above the bug. That is the cost rule 17
   * exists to name.
   *
   * ⚠⚠⚠ THE TOGGLE WRITES A COLUMN NOW — db/012, his ruling 2026-09-21.
   * ~~It used to flip the memo text: `withMark` on, `withoutMark` off,
   * with `markFor` choosing the word.~~ It sets `h.qualifier`.
   *
   * ⚠⚠ THE `withoutMark` CALL IS NOT LEFTOVER — IT IS THE ONE THING THAT
   * MAKES OFF STICK DURING THE TRANSITION. `qualifierOn` is his
   * compatibility read (`h.qualifier || readMark(h.memo)`), so on a
   * holding whose letters have not been carried over yet, setting
   * `qualifier = false` and leaving the memo alone would have the read
   * turn the toggle STRAIGHT BACK ON — an off tap that does nothing,
   * which is worse than either design on its own. So the tap strips the
   * mark WHATEVER DIRECTION IT GOES: the column is authoritative from
   * this tap onward, and stripping on the way ON as well keeps the memo
   * monotone toward `qualifierOn`'s retirement rather than leaving
   * letters for the next boot to find.
   * ⚠ It cannot be dropped until that read is. `pending-check` §6d
   * proves the off-tap on a memo-only holding.
   *
   * ⚠⚠ `save()` · `republish()` · `render()` — THE SAME THREE AS THE
   * GRADE TAP, and `republish` is there because db/012 put `qualifier`
   * in `public_holdings`. **A public field written without a republish
   * leaves a stranger looking at the old value** — his words, and the
   * asymmetry he spotted: the grade tap eight lines up has always had
   * all three. `pending-check` §6d asserts the three CALLS on this
   * handler, so the next public field cannot be added without them. */
  else if(t.dataset.setqual){const h=state.collection.find(x=>x.id===state.sel);h.qualifier=!qualifierOn(h);if(readMark(h.memo))h.memo=withoutMark(h.memo);clearPending(state,h.id,"qualifier");save();republish();render();}
  /* ⚠⚠ "SAVE NOTE TO COLLECTION" — HIS RULING 2026-09-21. A BACKUP to
   * autosave, which is untouched and still fires on every edit. It saves,
   * says so briefly, clears the stars for this note, and returns to the
   * vault. ⚠ `republish` because the grade is public, exactly as the grade
   * tap does it. */
  else if(t.dataset.savenote){flushNoFrFill(state,state.collection.find(x=>x.id===t.dataset.savenote));clearPendingFor(state,t.dataset.savenote);save();republish();state.screen="collection";render();toast("Saved");}
  /* ⚠ AN UPLOAD IN FLIGHT FOR A NOTE BEING REMOVED IS ABORTED FIRST —
   * 2026-09-13. The row is about to be deleted; a landing after that
   * fails its ref write with a tier set already stored — one more orphan
   * for Phase 7's sweep, bought for nothing. */
  else if(t.dataset.remove){abortSlotUploads(t.dataset.remove);state.collection=state.collection.filter(x=>x.id!==t.dataset.remove);save();republish();state.screen="collection";render();toast("Removed");}
});
/* ⚠ HIS WALK OF STEP 6, 2026-10-04 — the keyboard flipped back to letters
 * after every digit: each keystroke rebuilt the screen and the box with it.
 * Now the box is KEPT (`render({keep})`, render.js) while the results around
 * it are redrawn; the old re-focus runs only if keeping could not happen. */
const refocus=(inp)=>{if(inp){inp.focus();inp.setSelectionRange(inp.value.length,inp.value.length);}};
document.addEventListener("input",e=>{
  if(e.target.id==="q"){state.search=e.target.value;
    if(!render({keep:"#q"}))refocus($("q"));}
  if(e.target.id==="vq"){state.vSearch=e.target.value;
    if(!render({keep:"#vq"}))refocus($("vq"));}
  if(e.target.id==="cq"){state.cSearch=e.target.value;
    if(!render({keep:"#cq"}))refocus($("cq"));}
  if(e.target.id==="pq"){state.pSearch=e.target.value;
    if(!render({keep:"#pq"}))refocus($("pq"));}
  /* ⚠ STEP 7.3(c): A KEYSTROKE IN THE Fr FIELD CLEARS THE LOOKUP'S REFUSAL
   * LINE — the collector's act supersedes it and the field's own hint takes
   * over. Re-rendered ONLY when a line was there, so typing into `#cfr` on
   * an ordinary note costs no render; focus and caret restored the way the
   * search boxes above do it. The `change` that follows converts or stores
   * the Fr exactly as before. */
  if(e.target.id==="cfr"&&state.sel&&getLookup(state,state.sel)){clearLookup(state,state.sel);
    render();const inp=$("cfr");inp.focus();inp.setSelectionRange(inp.value.length,inp.value.length);}
  /* ══ STEP 6 — A KEYSTROKE IN A CARD FIELD RE-NARROWS LIVE (his ruling:
   * "correcting or adding any detail re-narrows the list live", and rule
   * 3: after a no-Fr answer too). The view narrows on render; the field is
   * KEPT in the page the way the search boxes are (his walk, 2026-10-04 —
   * the Series field takes digits). The star select fires `change`, below. */
  /* ⚠ STOP B, HIS CATCH: a keystroke moves the no-Fr fill in MEMORY only
   * (`save: false`) — the field's `change`, below, saves it once. */
  if(e.target.dataset&&e.target.dataset.rdf&&e.target.tagName!=="SELECT"&&state.sel){const f=e.target.dataset.rdf;
    if(setReadingField(state,state.sel,f,e.target.value)){syncNoFrFill(state,state.collection.find(x=>x.id===state.sel),{save:false});const k='[data-rdf="'+f+'"]';if(!render({keep:k}))refocus(document.querySelector(k));}}
});
/* ⚠ THE COLLECTOR'S OWN TYPE PICK, ONE COPY — Note details' Type (`#csection`) and, since problem 1 of his walk of
 * `8ff48b00`, the card's Type when it is his pick (the change handler below). The body was the `#csection`
 * handler's, moved word for word; every rule it carries is in that handler's comments. */
/* ⚠ HIS RULING A(i), 2026-10-30: *"confirming the AI's Other makes it mine and it sticks"* — a pick of Other while the
 * note is the AI's Other (`rd.noFr.section` standing) sets `keepOther` as a pick after "Not the right note?" does;
 * read before the fill's mark is dropped below. A pick of Other from "Custom entry" on a note never converted still
 * does not stick (his answer 2, slab-check (8c)). */
function pickSection(h,n,v){const was=n.section,r0=getReading(state,h.id),ai=!!(r0&&r0.noFr&&r0.noFr.section);n.section=v;if(n.section===OTHER_TYPE&&n.reverted)n.keepOther=true;else delete n.keepOther;if(n.section===OTHER_TYPE&&was===OTHER_TYPE&&ai)n.keepOther=true;if(n.section===OTHER_TYPE&&was!==OTHER_TYPE&&enterOther(h))save();const rd=getReading(state,h.id);if(rd){rd.noFr=rd.noFr||{};delete rd.noFr.section;rd.noFr.sectionMine=n.sid;}
    if(rd&&TYPE_OPTIONS.includes(n.section)){setReadingField(state,h.id,"type",n.section);syncNoFrFill(state,h);}
    saveCustom();republish();render();}
document.addEventListener("change",e=>{
  if(e.target.id==="unameInput"){setUsername(e.target.value);return;}
  const h=state.collection.find(x=>x.id===state.sel);if(!h)return;
  /* STEP 6: the card's pick-lists (Type, Charter period, Variety, Star,
   * the Bank) — one event each, so the no-Fr fill saves at once (stop B). */
  /* ⚠ The Type select's LEAD option (the question, or the read heading) is
   * not a pick: choosing it leaves the read state exactly as it was. */
  if(e.target.dataset&&e.target.dataset.rdf==="type"&&e.target.value===TYPE_LEAD){render();return;}
  /* A1 (2026-10-30): the AI-filled Other's own lead, picked again — the same no-op (pending.js `OTHER_LEAD`) */
  if(e.target.dataset&&e.target.dataset.rdf==="type"&&e.target.value===OTHER_LEAD){render();return;}
  /* ⚠ PROBLEM 1 OF HIS WALK OF `8ff48b00`, HIS RULINGS: *"a pick of Other on the card counts as my hand pick"*, and
   * option i, *"a catalogue pick on the card when the note is Other by my hand counts as my hand pick too — the note
   * leaves Other for that type, as in Note details."* Both go through Note details' own pick (`pickSection`), so Other
   * never reaches the reading and the 22 types narrow as before. ~~An Other the AI filled is not his: a catalogue pick
   * there follows the card as it always has.~~ ⚠ HIS B1, 2026-10-30 (*"B: B1"*): a catalogue pick on the AI's Other
   * is his hand pick too — the note leaves Other for that type, and where nothing matches the card shows the
   * "nothing matches" line under HIS type instead of Other again (his walk of `758af329`, step 7). The first line
   * below is that case; the second is his Other (option i) and Other itself, as before. */
  if(e.target.dataset&&e.target.dataset.rdf==="type"){const n=cat(h.catId);const rd=getReading(state,h.id);
    if(isCust(n)&&isOther(n)&&rd&&rd.noFr&&rd.noFr.section&&TYPE_OPTIONS.includes(e.target.value)){pickSection(h,n,e.target.value);return;}
    if(isCust(n)&&(e.target.value===OTHER_TYPE||(isOther(n)&&!(rd&&rd.noFr&&rd.noFr.section)&&TYPE_OPTIONS.includes(e.target.value)))){pickSection(h,n,e.target.value);return;}}
  /* ⚠ On a QUESTION row (the amendment) the lead is the question itself:
   * picking it again clears the answer, so the question comes back. */
  if(e.target.dataset&&e.target.dataset.rdf&&e.target.tagName==="SELECT"){setReadingField(state,h.id,e.target.dataset.rdf,e.target.value===TYPE_LEAD?"":e.target.value);syncNoFrFill(state,h);render();return;}
  /* STOP B: a card text field's edit has settled — save its fill, once. */
  if(e.target.dataset&&e.target.dataset.rdf){flushNoFrFill(state,h);return;}
  if(e.target.id==="cfr"){const n=cat(h.catId);if(!isCust(n))return;const v=e.target.value.trim();
    const m=CATALOG.filter(x=>x.fr&&x.fr.toLowerCase()===v.toLowerCase());
    /* ⚠ THE CONVERSION IS `convertToRow` IN `custom.js` SINCE 7.3 (2026-09-23)
     * — the catId, the year, the grade re-pick, the drop, the saves. It
     * was inline here from Phase 1; it moved so the slab lookup runs the
     * SAME conversion and not a copy. This handler keeps the render and
     * the toast, because the collector is on the screen. */
    if(v&&m.length===1){const t=m[0];convertToRow(h,t);render();toast(MATCHED_TOAST(t.fr));return;}
    n.fr=v.slice(0,18);saveCustom();republish();render();return;}
  if(e.target.id==="cdenom"){const n=cat(h.catId);if(!isCust(n))return;let v=e.target.value.trim().slice(0,14);
    if(v&&/^\d+(\.\d+)?$/.test(v))v="$"+v;
    /* STEP 6: typed by the collector now — the raw fill's ✨ goes, as the grade's does on a tap. */
    n.denom=v;n.fd=v;clearPending(state,h.id,RAW_FILL_FIELD);saveCustom();republish();render();return;}
  /* STOP B: the collector's own Type or state — the no-Fr fill's ✨ goes and
   * the rule never touches that field again while the card is up. */
  /* ⚠ HIS #11, 2026-09-28: *"An edit to State or Type in Note details
   * carries back to the card's matching row, marked ✎."* The Type carries
   * back when it is one of the card's own options ("Custom entry" is not);
   * the state always. The card then re-narrows on the render, and the
   * no-Fr fill follows the card's new answer — never the field the
   * collector just set, whose mark is dropped first. */
  /* ⚠ HIS RULING OF 2026-10-05: the collector's own Type and State or colony
   * are FINAL while the card is up — "Custom entry" and an empty state
   * included — recorded against this entry (`sectionMine` / `descMine`), and
   * the fill (suggest.js `syncNoFrFill`) never touches them again. */
  /* ⚠ OTHER'S STEP 5, HIS A: a pick that puts the note INTO Other takes a
   * VF20 off (custom.js `enterOther`), saved with the holding. */
  /* ⚠ OTHER'S STEP 4, HIS ANSWER 2: *"Only a pick of Other I make by hand
   * after a photo converted the note sticks."* Other picked here on an entry
   * "Not the right note?" made (`reverted`) is kept (`keepOther`: a later
   * label's Fr no longer converts it); any other pick takes it off. Saved
   * with the Type. */
  if(e.target.id==="csection"){const n=cat(h.catId);if(!isCust(n))return;if(e.target.value===OTHER_LEAD){render();return;}pickSection(h,n,e.target.value);return;}
  if(e.target.id==="cstate"){const n=cat(h.catId);if(!isCust(n))return;n.desc=e.target.value.trim().slice(0,40);const rd=getReading(state,h.id);if(rd){rd.noFr=rd.noFr||{};delete rd.noFr.desc;rd.noFr.descMine=n.sid;}
    if(rd){setReadingField(state,h.id,"state",n.desc);syncNoFrFill(state,h);}
    saveCustom();republish();render();return;}
  /* The custom grade's number — his ruling 2026-09-17. Digits only; 1–70 is
   * the key "custom:NN", anything else is the bare chip. It is the grade, so
   * it republishes like a tab tap does. */
  if(e.target.id==="cgn"){h.grade=customGradeKey(+e.target.value.replace(/[^0-9]/g,"").slice(0,2)||0);const cn=cat(h.catId);if(cn&&cn.gradeRead!=null&&cn.gradeRead!==h.grade){delete cn.gradeRead;saveCustom();}save();republish();render();}
  if(e.target.id==="cost"){h.cost=e.target.value.replace(/[^0-9]/g,"");save();render();}
  if(e.target.id==="ref"){h.ref=e.target.value.slice(0,40);save();}
  /* a typed year is the collector's: the photo's ✨ goes (his ruling 2 of 2026-10-26, rule 2 of 4.3) */
  if(e.target.id==="yr"){h.year=e.target.value.replace(/[^0-9]/g,"").slice(0,4);clearPending(state,h.id,YEAR_FILL_FIELD);save();republish();render();}
  if(e.target.id==="appr"){h.appr=e.target.value.replace(/[^0-9]/g,"");save();render();}
  if(e.target.id==="acq"){h.acq=e.target.value;save();}
  /* render() here since 3.5: the toggle reads this field, so what is typed into it must show. */
  if(e.target.id==="memo"){h.memo=e.target.value;save();render();}
});
document.addEventListener("keydown",e=>{if(e.target.id==="unameInput"&&e.key==="Enter"){e.preventDefault();setUsername(e.target.value);}});

/* ── ⚠⚠ THE ONLY THING THAT RE-ASKS THE BATCH ROUTE AFTER A FAILURE ──
 * PHASE 4, STEP 7. `loadCommunityThumbs` REMEMBERS a failed load and
 * short-circuits on it, because `hydratePhotos` runs on every `render()`
 * and `vPublicProfile` carries a search box — without that, one dead
 * endpoint would be asked once per keystroke. Clearing the remembered
 * failure is therefore the whole of what a Retry is, and this is the only
 * caller of it.
 *
 * ⚠ IT DOES NOT CLEAR WHAT THE SERVER ALREADY ANSWERED. Ids that came
 * back unresolved from a request that SUCCEEDED stay cached; only the
 * ids inside a chunk that failed were never cached, so those are exactly
 * what the next render re-asks. */
document.addEventListener("click",e=>{
  const t=e.target.closest("[data-pphretry]");
  if(!t)return;
  retryCommunityPhotos({username:t.dataset.pphretry,slot:"front",tier:TIER_FOR.community});
  render();
});

/* ── THE SAME THING FOR THE NOTE DETAIL — PHASE 4, STEP 9 PART ONE ───
 *
 * ⚠⚠ IT CLEARS BOTH SLOTS, AND A ONE-SLOT RETRY WOULD BE A BUTTON THAT
 * HALF WORKS. A failure scope is `(username, subject, slot, tier)`, so
 * the note detail's two requests leave TWO remembered failures. Lifting
 * only `front` would leave the back frame's block in place and the
 * notice would come straight back with the button that had just been
 * pressed still showing.
 *
 * ⚠ SEPARATE ATTRIBUTE FROM `data-pphretry` RATHER THAN A SHARED ONE,
 * because the tier differs: the profile's thumbs and this screen's
 * `display` frames are different cache scopes, and a single handler
 * clearing both tiers would silently re-ask for the profile's forty
 * thumbnails on a retry pressed over one note. */
document.addEventListener("click",e=>{
  const t=e.target.closest("[data-ppnretry]");
  if(!t)return;
  for(const slot of ["front","back"])
    retryCommunityPhotos({username:t.dataset.ppnretry,slot,tier:TIER_FOR.detail});
  render();
});

/* ══ ⚠⚠⚠ THE ENLARGE — PHASE 4, STEP 9, THE "+1" ═══════════════════
 *
 * ⚠ THE TAP TARGET IS `data-ppzoom`, WHICH `hydratePhotos` SETS ONLY ON
 * A FRAME THAT ACTUALLY RECEIVED A PHOTOGRAPH. An empty side and a
 * failed fetch both leave the attribute off, so this handler cannot fire
 * over a frame with nothing behind it — the affordance, the handler and
 * the content are one condition rather than three that agree today.
 *
 * ⚠⚠ IT SETS STATE AND RE-RENDERS RATHER THAN BUILDING THE OVERLAY
 * HERE. `render()` rebuilds this screen's innerHTML on every pass, so a
 * viewer constructed in the DOM by this handler would be destroyed by
 * the next render — a retry on the frames behind it, for instance. The
 * open viewer is a fact about the app, so it lives in `state`. */
document.addEventListener("click",e=>{
  const t=e.target.closest("[data-ppzoom]");
  if(!t)return;
  state.pubZoom=t.dataset.ppzoom;
  render();
});

/* ⚠ CLOSE IS A STATE CHANGE AND NOTHING ELSE. It does NOT clear the
 * archive tier from the cache: the collector may well tap back in, the
 * archive bytes are already paid for, and re-fetching them to save
 * memory would spend their connection to buy nothing they asked for. */
document.addEventListener("click",e=>{
  if(!e.target.closest("[data-ppzclose]"))return;
  state.pubZoom=null;
  render();
});

/* ⚠⚠ THE ENLARGE'S RETRY CLEARS ONE SLOT AT ONE TIER, WHICH IS THE
 * OPPOSITE OF `data-ppnretry` ABOVE AND DELIBERATELY SO. That one clears
 * both slots because the notice it sits under speaks for both frames.
 * This one sits under a viewer showing ONE side at `archive`, so
 * widening it would re-ask for the other side's archive bytes — a hidden
 * second download from a button that names one photograph. */
document.addEventListener("click",e=>{
  if(!e.target.closest("[data-ppzretry]"))return;
  if(!state.pubZoom)return;
  retryCommunityPhotos({username:state.viewUser,slot:state.pubZoom,tier:TIER_FOR.zoom});
  render();
});

/* ══ ⚠⚠⚠ THE VAULT ENLARGE — THE OWNER'S SIDE, DECIDED BY JESSE
 * 2026-09-03. TILE TAP OPENS, THE CHIP ALONE REPLACES ════════════════
 *
 * ⚠⚠⚠ THE FIRST LINE OF THE BODY IS LOAD-BEARING AND MUST NOT BE READ AS
 * DEFENSIVE. The Replace chip is a `<button data-photoadd>` NESTED INSIDE
 * the frame that carries `data-vzoom`, so a tap on Replace matches BOTH
 * this handler and `editor.js`'s. Without the bail, one deliberate tap on
 * Replace opens the file picker and the viewer together. ⚠ Deleting it
 * does not break the enlarge — it breaks Replace, on the app's one
 * destructive control, which is the failure least likely to be noticed by
 * whoever deletes it.
 *
 * ⚠ THE ORDER OF THE TWO HANDLERS IS NOT WHAT SAVES IT. Both are on
 * `document` and both would run; the guard is what makes the chip mean
 * one thing.
 *
 * ⚠⚠ `data-vzoom` IS SET BY `hydratePhotos`, NEVER BY THE VIEW. The view
 * renders every frame as a picker target; hydration is the only thing
 * that knows a photograph actually landed, so it is the only thing that
 * can say a frame is enlargeable. The affordance, the handler and the
 * content stay one condition rather than three that agree today. */
/* ⚠⚠ `[data-photocam]` WAS ADDED HERE FOR THE TAKE PHOTO CHIP AND
 * REMOVED WITH IT — 2026-09-06, JESSE'S RULING. His reasoning: it was
 * widened FOR the chip, the chip is gone, and case 3 already covers the
 * `[data-photoadd]` half. **Do not leave a term no case can watch
 * fail** inside a line that IS watched. ⚠ `editor.js`'s twin kept its
 * `[data-photocam]` term by the same ruling for the opposite reason —
 * see the note there. */
document.addEventListener("click",e=>{
  if(e.target.closest("[data-photoadd]"))return;
  const t=e.target.closest("[data-vzoom]");
  if(!t)return;
  state.vaultZoom=t.dataset.vzoom;
  render();
});

/* ⚠ CLOSE IS A STATE CHANGE AND NOTHING ELSE — as on the Community side. */
document.addEventListener("click",e=>{
  if(!e.target.closest("[data-vpzclose]"))return;
  state.vaultZoom=null;
  render();
});

/* ⚠ THE VAULT RETRY IS A BARE RE-RENDER, AND WHAT MAKES THAT A REAL
 * RETRY IS NARROWER THAN "THERE IS NO CACHE" — THERE IS ONE.
 * `resolveSlot` holds `tierCache`, keyed `(id, slot, tier)`
 * (`photo-view.js:215-217`). It caches SUCCESSES: both UNAVAILABLE
 * returns hand back the local URL and exit BEFORE `tierCache.set`, so a
 * slot that failed is not remembered as failed and the next call
 * re-fetches it. That is the whole reason this needs no
 * `retryCommunityPhotos` equivalent — `community-photos.js` caches the
 * FAILURE, and would answer a retry with it.
 *
 * ⚠⚠ SO THE PROPERTY THIS LINE DEPENDS ON IS "FAILURES ARE NOT CACHED",
 * NOT "NOTHING IS CACHED". If a negative entry is ever added to
 * `tierCache`, this button silently stops retrying while going on
 * rendering — it would still look like it worked. */
document.addEventListener("click",e=>{
  if(!e.target.closest("[data-vpzretry]"))return;
  if(!state.vaultZoom)return;
  render();
});

/* ⚠ "TRY AGAIN" ON A VAULT THAT DID NOT LOAD — the offline-reload item, his go 2026-10-18. It runs the boot's
 * own steps again IN PLACE: there is no service worker, so a page reload while offline would lose the app to
 * the browser's error page. `ensureVault` caches only a success, so this really reads again; a session that
 * ended meanwhile lands on the sign-in screen with its sentence. The render is in the `finally` (his
 * instruction): the button can never stay on "Trying…" if the boot or a step after it throws. */
document.addEventListener("click",async e=>{
  if(!e.target.closest("[data-vaultretry]"))return;
  if(state.vaultRetrying)return;
  state.vaultRetrying=true;render();
  try{await bootSession();backfillYears();carryOverQualifier();}
  finally{state.vaultRetrying=false;render();}
});

/* ══ THE OFFLINE BAR — the offline-add item, his ruling 2026-10-22 ══════
 * Shown (a) when the window says so — the `offline` event, or `navigator.onLine`
 * false at boot — and (b) when a save never reached the server: `save()`
 * (state.js) dispatches `ck:savefailed` with the error's status, and 0 is
 * remote.js's status-0 path, the "No connection" toast's. Hidden on the
 * `online` event, or on the next successful save (`ck:saved`). ⚠ NOTHING
 * HERE RE-SAVES, and nothing keeps a copy: the bar is the whole fix, and a
 * note added offline is still lost on a reload while offline — by design,
 * his ruling; the bar's sentence says so. The bar is toggled directly
 * (`offbar`, render.js), never by a full render, so a field being typed in
 * is not disturbed when the connection changes. */
window.addEventListener("offline",()=>{state.offline=true;offbar();});
window.addEventListener("online",()=>{state.offline=false;offbar();});
document.addEventListener("ck:savefailed",e=>{if(e.detail&&e.detail.status===0){state.offline=true;offbar();}});
document.addEventListener("ck:saved",()=>{if(state.offline){state.offline=false;offbar();}});

/* ══ THE WIDE LAYOUTS — his rulings of 2026-10-23 and 2026-10-24 ══════════
 * Crossing 1100px redraws: one pane or two (render.js `inPanes`), the open note kept with its scroll. Crossing
 * 768px only re-marks the screen for the stylesheet: A is CSS, so nothing is redrawn and a field being typed in,
 * an open editor or an open sheet are untouched. With no `matchMedia` nothing is registered — the phone. */
function watchWidth(q,fn){try{const m=typeof window.matchMedia==="function"?window.matchMedia(q):null;if(!m)return;if(typeof m.addEventListener==="function")m.addEventListener("change",fn);else if(typeof m.addListener==="function")m.addListener(fn);}catch(e){}}
watchWidth(WIDE_A,()=>markLayout());
watchWidth(WIDE_B,()=>render({layout:true}));

/* ⚠ THE LANDING RUNS BEFORE `isSignedIn()` IS CONSULTED — Phase 5 step 3,
 * 2026-09-09. A confirmation link arrives as a URL fragment on a page
 * load; `bootFromUrl` consumes it (or returns false when there is
 * nothing to consume) and, when it produced a session, has already run
 * `bootSession()`. The ordinary two branches are unchanged for every
 * load that carries no fragment. */
/* the offline bar's boot half: a page opened with no connection says so from the first paint */
(async function(){state.offline=typeof navigator!=="undefined"&&navigator.onLine===false;buildDemos();const landed=HAS&&await bootFromUrl();if(!landed){if(HAS&&isSignedIn()){await bootSession();}else if(HAS){state.screen="signin";}}backfillYears();carryOverQualifier();loadPublic();render();})();


// Nothing to export — this module runs for its side effects
// (it registers event listeners at load time).


